import React, {Fragment} from "react";
import {connect} from "react-redux";
import { usePopperTooltip } from 'react-popper-tooltip';
import { createPortal } from 'react-dom';
import {noop} from "../utils";

const Tooltip = ({props, onTriggerClick = noop()}) => {
    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible,
    } = usePopperTooltip({
        trigger: 'hover',
        placement: 'top',
        offset: 3,
    }, {strategy: 'fixed'});

    return (
        <Fragment>
            <button ref={setTriggerRef} className={`${props.className}`} onClick={onTriggerClick}>
                {props.children}
            </button>

            {visible && (
                createPortal(
                    <div
                        ref={setTooltipRef}
                        {...getTooltipProps({ className: 'tooltip fade show bs-tooltip-top' })}
                    >
                        <div {...getArrowProps({ className: 'tooltip-arrow' })} />
                        <div className={"tooltip-inner"}>{props.content}</div>
                    </div>,
                    props.target ? document.getElementById(props.target) : document.getElementsByTagName('body')
                )
            )}
        </Fragment>
    );
};


export function mapStateToProps(state, props) {
    return {
        props
    }
}

export default connect(mapStateToProps)(Tooltip)